import React from 'react'
import { EmptyData } from '@intelie/ui'
import styled from 'styled-components'

type Prop = {
    title: string
    subtitle?: string
}

const EmptyPurgeData = ({ title, subtitle }: Prop): JSX.Element => {
    return (
        <Container>
            <EmptyData title={title} subtitle={subtitle} />
        </Container>
    )
}

const Container = styled.div`
    height: 234px;
    border: 1px solid var(--gray-400);
    border-radius: 3px;
    margin-bottom: 20px;
`

export default EmptyPurgeData
